import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map({});

export default class RenderContextBoundComponent extends React.PureComponent {
	getData() {
		return this.props.data || EMPTY_MAP;
	}

	setRootProperty(path, value) {
		this.props.ctx.setRootProperty(path, value);
	}

	getRootProperty(path) {
		this.props.ctx.getRootProperty(path);
	}

	setProperty(path, value) {
		this.props.ctx.setProperty(path, value);
	}

	getProperty(path) {
		this.props.ctx.getProperty(path);
	}

	setData(value) {
		this.props.ctx.setData(value);
	}

}
